import { arDocIdKeyFn } from './arDocIdKeyFn';
import { AccountDocument } from '../type';

export const arDocIdKeysTransform = (accountDocuments: AccountDocument[] | undefined) => {
  const result = (accountDocuments ? accountDocuments.map((l) => arDocIdKeyFn(l)) : []);
  return result;
};
